import localeWatcher from './locale-watcher'

export default [
  localeWatcher
]



// WEBPACK FOOTER //
// ./src/store/plugins/index.js